// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__nLEDO","content":"LoadingAlert_content__1QigZ"};